export default __webpack_public_path__ + "static/1132-3141d58e4bda3a0481ed1b35c7c70a45.gif";